import { Link } from "react-router-dom";
import { TEAM, IMAGES } from "@/data/content";

export default function Team() {
  return (
    <div data-testid="page-team">
      <section className="py-16 md:py-20 border-b border-[#24211D]/10">
        <div className="max-w-6xl mx-auto px-6">
          <span className="text-xs uppercase tracking-[0.2em] text-[#B08D57] block mb-2 font-sans">Persönliche Betreuung</span>
          <h1 className="text-[clamp(36px,4.5vw,64px)] leading-tight mb-6">Das ist Nes.</h1>
          <p className="text-base text-[#24211D]/80 max-w-2xl leading-relaxed">
            Inhaberin, Friseurmeisterin und das Herz des Studios. Nes beherrscht das ganze Handwerk – vom präzisen Schnitt über Farbe und Pflege bis zum festlichen Styling – und betreut Sie von Anfang bis Ende persönlich. Ihre besondere Leidenschaft gilt Balayage und Hochsteckfrisuren.
          </p>
          <p className="text-base text-[#24211D]/80 max-w-2xl leading-relaxed mt-4">
            Ihr Handwerk hat Nes von Grund auf gelernt: In verschiedenen Kölner Salons sammelte sie Erfahrung, seit rund vier Jahren arbeitet sie in Glessen – zuerst viele Jahre als Mitarbeiterin in genau diesem Laden, dessen Inhaberin sie im Februar 2026 wurde. 35 Jahre Friseurin, davon 15 Jahre Meisterin – und was sie antreibt, ist bis heute dasselbe wie am ersten Tag.
          </p>
          <p className="text-base text-[#24211D]/80 max-w-2xl leading-relaxed mt-4">
            Wenn sie nicht im Salon steht, ist sie mit ihren Kindern unterwegs oder trifft sich mit Freunden zum Kaffee. Und was sagen ihre Kundinnen und Kunden? Dass sie den richtigen Beruf gewählt hat – und dass sie sich bei Nes einfach wohlfühlen.
          </p>
        </div>
      </section>

      <section className="py-16 border-b border-[#24211D]/10">
        <div className="max-w-6xl mx-auto px-6 grid grid-cols-1 sm:grid-cols-2 gap-8">
          {TEAM.map((m, i) => (
            <div key={m.name} className="border border-[#24211D]/15 bg-[#FFFFFF]" data-testid={`team-card-${i}`}>
              <figure className="aspect-[4/5] overflow-hidden border-b border-[#24211D]/10">
                <img src={m.img} alt={m.placeholder ? `Symbolfoto – echtes Teamfoto folgt (${m.name})` : `Portrait: ${m.name}, ${m.role}`} className="w-full h-full object-cover" loading="lazy" />
              </figure>
              <div className="p-8">
                <span className="text-[10px] uppercase tracking-[0.2em] text-[#B08D57] block mb-2 font-sans">{m.role}</span>
                <h2 className="text-2xl mb-3">{m.name}</h2>
                {m.about && (
                  <p className="text-xs font-sans text-[#B08D57] border-l-2 border-[#B08D57]/50 pl-3 mb-4 leading-relaxed" data-testid={`team-about-${i}`}>
                    Über mich: {m.about}
                  </p>
                )}
                <p className="text-xs text-[#24211D]/75 leading-relaxed font-sans mb-4">{m.bio}</p>
                {m.placeholder && (
                  <span className="text-[10px] text-[#24211D]/50 font-sans block" data-testid={`team-placeholder-note-${i}`}>Symbolfoto – echtes Foto folgt in Kürze.</span>
                )}
              </div>
            </div>
          ))}
          <div className="border border-[#B08D57]/40 bg-[#F4EFE6] p-8 flex flex-col justify-center" data-testid="team-join-card">
            <span className="text-[10px] uppercase tracking-[0.2em] text-[#B08D57] block mb-2 font-sans">Dein Platz hier?</span>
            <h2 className="text-2xl mb-3">Wir suchen Verstärkung</h2>
            <p className="text-xs text-[#24211D]/75 leading-relaxed font-sans mb-6">
              Friseur/in oder Auszubildende/r gesucht – familiäres Team, geregelte Zeiten, kein Sonntags- und Montagsdienst.
            </p>
            <Link to="/karriere" data-testid="team-career-link" className="text-xs uppercase tracking-widest text-[#B08D57] hover:text-[#24211D] font-sans transition-colors duration-200">
              Zu den offenen Stellen →
            </Link>
          </div>
        </div>
      </section>

      <section className="bg-[#24211D] text-[#FBF8F3] py-16">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <span className="text-xs uppercase tracking-[0.2em] text-[#B08D57] block mb-3 font-sans">Unsere Philosophie</span>
          <p className="font-display text-2xl md:text-3xl leading-relaxed" data-testid="team-philosophy">
            „Wenn die Kundin glücklich ist, bin ich es auch. Dafür mache ich diesen Beruf – seit 35 Jahren, und noch viele weitere."
          </p>
          <span className="block mt-4 text-xs uppercase tracking-[0.2em] text-[#FBF8F3]/60 font-sans">Nes · Inhaberin &amp; Friseurmeisterin</span>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-6xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <figure className="aspect-[4/3] border border-[#24211D]/10 overflow-hidden">
            <img src={IMAGES.storefront} alt="Außenansicht des Haarstudio Nes in Glessen" className="w-full h-full object-cover" loading="lazy" />
          </figure>
          <div>
            <h2 className="text-3xl md:text-4xl mb-5">Ein Salon, eine persönliche Betreuung</h2>
            <p className="text-sm text-[#24211D]/80 leading-relaxed mb-6">
              Entspannen Sie bei Kaffee und Wohlfühlambiente in Glessen. Individuelle Farb- und Pflegeberatung, exakt auf Ihre Wünsche abgestimmt – und dank kurzer Wartezeiten sind Sie schnell dran.
            </p>
            <Link to="/kontakt#termin" data-testid="team-booking-link" className="bg-[#24211D] hover:bg-[#3D3832] text-[#FBF8F3] px-8 py-3.5 text-xs uppercase tracking-[0.18em] font-sans transition-colors duration-300 inline-block">
              Termin vereinbaren
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
